<template>
  <div></div>
</template>
<script>
  import { mapActions } from 'vuex'
  import Vue from 'vue'
  export default {
    methods: {
      ...mapActions(['track']),
      goBackHandler () {
        Vue.sensorsTrack("CancelApplication", {
          current_page: document.title,
          cancel: false,
        })
        this.$alert(' 申请尚未完成，返回首页后您可在48小时内继续当前申请！ ', '提示', {
          center: true,
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: '继续申请',
          cancelButtonText: '返回首页'
        }).catch(() => {
          Vue.sensorsTrack("CancelApplication", {
            current_page: document.title,
            cancel: true,
          })
          this.$router.replace({
            name: 'index'
          })
        })
      },
      setBodyColor (color) {
        color = color || '#F8F8F8';
        document.getElementsByTagName('body')[0].style['backgroundColor'] = color;
      }
    }
  }
</script>